export const PATTERNS = {
  dot: ".",
  medicalHistory: "@call",
};
